import { getDefaultStore, useAtomValue } from 'jotai';

import { enqueueModalAtom, seenModalIdsAtom } from '@/atoms/modalQueueAtoms';
import { useQueuedModal } from '@/hooks/useQueuedModal';
import { type QueuedModal } from '@/types/modal-queue.types';
import type { QueuedModalDescriptor } from '@heidi/dictate';
import { configureDictationModalQueuePorts } from '@heidi/dictate';
import { type ModalId } from '@heidi/schema/ml-scribe';

/**
 * Binds the app modal queue into @heidi/dictate's queue-ports seam. The
 * subscription hook crosses BY REFERENCE (rules of hooks apply through it);
 * the launch writes go through the jotai default store, which is the same
 * store the atoms live in. No tier, priority, id, or dismissibility changes —
 * the queue's behavior is untouched; only the route to it moved.
 */

const defaultStore = getDefaultStore();

const enqueueModal = (modal: QueuedModalDescriptor): void => {
  defaultStore.set(enqueueModalAtom, modal as QueuedModal);
};

const getSeenModalIds = (): Set<ModalId> | null => defaultStore.get(seenModalIdsAtom);

const markModalSeen = (modalId: ModalId): void => {
  defaultStore.set(seenModalIdsAtom, (prev) => new Set([...(prev ?? []), modalId]));
};

const useSeenModalIds = (): Set<ModalId> | null => useAtomValue(seenModalIdsAtom);

export const tauriDictationModalQueuePorts = {
  useQueuedModal,
  enqueueModal,
  getSeenModalIds,
  useSeenModalIds,
  markModalSeen,
};

configureDictationModalQueuePorts(tauriDictationModalQueuePorts);
